export const formatArrivingTime = (seconds) => {
  const totalDays = Math.floor(seconds / 86400);
  const totalHours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (totalDays > 0) {
    return `${totalDays} day${totalDays > 1 ? "s" : ""} ${totalHours} hour${
      totalHours > 1 ? "s" : ""
    } ${minutes} minute${minutes > 1 ? "s" : ""}`;
  } else if (totalHours > 0) {
    return `${totalHours} hour${totalHours > 1 ? "s" : ""} ${minutes} minute${
      minutes > 1 ? "s" : ""
    }`;
  } else {
    return `${minutes} minute${minutes > 1 ? "s" : ""}`;
  }
};
